<template>
  <div :class="isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'"
    class="fixed inset-0 bg-black bg-opacity-50 z-40 transition-all duration-700 ease-in-out overflow-hidden"
    @click="isMobileMenuOpen = false"></div>
  <div :class="[
    ' z-50 transition-all duration-300',
    isScrolled ? 'fixed top-0 bg-white shadow-md' : ' top-0 left-0 laptop:relative'
  ]">
    <header :class="[
      'mainHeader w-full z-50 transition-all duration-300 ease-in-out mobile:!p-0',
      isScrolled
        ? 'fixed top-0 bg-white shadow-md laptop:w-[calc(100%-15px)]'
        : 'absolute top-0 left-0 laptop:relative !bg-transparent'
    ]">
      <nav
        class="navbar laptop:h-[70px] largeDesktop:h-24 mobile:h-auto navbar-expand-lg shadow-md mobile:px-2 largeDesktop:px-3 py-3 px-lg-2 z-10 mobile:rounded-br-[40px] tablet:rounded-br-[50px] bg-white">
        <div class="container-fluid header-container">
          <!-- Logo -->
          <a id="tour-logo" @click="logoClicked()" :class="[
            'relative flex items-center rounded-full border-2 shadow-lg border-white p-0 transition-all duration-300 mr-5 cursor-pointer',
            isScrolled
              ? 'w-[50px] h-[50px] laptop:w-[60px] laptop:h-[60px] largeDesktop:w-[80px] largeDesktop:h-[80px]'
              : 'mobile:w-[60px] mobile:h-[60px] laptop:w-[90px] laptop:h-[90px] largeDesktop:w-[150px] largeDesktop:h-[150px] laptop:top-9 largeDesktop:top-11'
          ]">
            <img src="../../../assets/images/happyHomeLogo.svg" alt="Logo" class="w-full h-full object-contain">
          </a>
          <div class="flex items-center gap-3">
            <div id="tour-role-badge" class="mobile:block laptop:hidden">
              <div v-if="user.user.affiliate.affiliate_type == 'normal'"
                class="flex items-center justify-center gap-1.5 text-[14px] px-[15px] h-[30px] rounded-full font-roboto font-semibold shadow-custom text-[#666666]">
                <img src="../../../assets/images/people-icon.png" class="w-[20px] h-[20px] object-contain" alt="icon">
                Standard Affiliate
              </div>
              <div v-else-if="user.user.affiliate.affiliate_type == 'master'"
                class="flex items-center justify-center gap-1.5 text-[14px] px-[15px] h-[30px] rounded-full font-roboto font-semibold shadow-custom text-[#666666]">
                <img src="../../../assets/images/master-icon.png" class="w-[20px] h-[20px] object-contain" alt="icon">
                Master Affiliate
              </div>
              <div v-else-if="user.user.affiliate.affiliate_type == 'employee'"
                class="flex items-center justify-center gap-1.5 text-[14px] px-[15px] h-[30px] rounded-full font-roboto font-semibold shadow-custom text-[#666666]">
                <img src="../../../assets/images/building-icon.png" class="w-[20px] h-[20px] object-contain" alt="icon">
                Employee
              </div>
            </div>
            <!-- search button for mobile  -->
            <button v-if="!isMobileMenuOpen" @click="toggleSearch" ref="searchButton" class="hidden w-8 h-8 "
              type="button" data-bs-target="#globalSearch" data-bs-toggle="collapse">
              <img :src="searchOpen ? crossIcon : searchIcon" alt="searchicon" class="w-full">
            </button>

            <!-- Toggle Button for Mobile -->
            <button class="navbar-toggler focus:!outline-none focus:!shadow-none collapsed p-0 border-0" type="button"
              aria-label="Toggle navigation" @click="isMobileMenuOpen = !isMobileMenuOpen">
              <!-- <span class="navbar-toggler-icon"></span> -->
              <img v-if="!isMobileMenuOpen" src="../../../assets/images/hamburger-icon.svg" alt="Hamburger Icon"
                class="w-8 h-8 object-contain">
              <img v-else src="../../../assets/images/hamburger-times-icon.svg" alt="Hamburger Icon"
                class="w-8 h-6 object-contain">
            </button>
          </div>
          <!-- Navbar Content -->
          <div class="navbar-collapse mobile:!m-0 laptop:block !ml-5 overflow-hidden
          transition-all duration-700 ease-in-out" :class="[
            isMobileMenuOpen
              ? 'laptop:min-h-auto laptop:max-h-auto overflow-y-auto custom-scrollbar mobile:max-h-[70vh] mobile:pr-2 tablet:pr-0 tablet:max-h-[auto] px-[0.5rem]'
              : 'mobile:max-h-[0px] mobile:opacity-0 laptop:!opacity-100 laptop:!max-h-max'
          ]">
            <div class="mobile:flex mobile:flex-col-reverse laptop:flex-row items-center justify-between w-full ">
              <div class="mobile:flex laptop:hidden largeDesktop:hidden items-start gap-5 w-full">
                <sidebarNavigation :setSideMenuClicked="sideMenuClicked" />
                <!-- <sidebar/> -->
              </div>

              <!-- Left Side Nav -->
              <ul
                class="laptop:pl-1 mobile:hidden laptop:flex navbar-nav mobile:w-full mobile:gap-2 mobile:py-3 laptop:w-2/3 largeDesktop:py-0 largeDesktop:me-auto largeDesktop:gap-2 mb-3 mb-lg-0 border-b border-[#EFEFEF] laptop:border-0">
                <li v-if="$route.name != 'dashboard'" class="hidden">
                  <a @click="backButton()"
                    class="cursor-pointer w-10 h-10 p-2 rounded-full flex items-center justify-center hidden laptop:!block bg-gradient-to-r from-[#16BCFF] to-[#168EFF]">
                    <img src="../../../assets/images/back-arrow-icon.png" alt="Back Arrow Button" class="w-full h-full">
                  </a>
                </li>
                <li v-for="(item, index) in getNavItems" :key="index">
                  <component :is="item.type == 'path' ? 'router-link' : 'a'"
                    :to="item.type == 'path' ? item.link : null" @click="isMobileMenuOpen = false"
                    :href="item.type != 'path' ? item.link : null" :target="item.type != 'path' ? '_blank' : null"
                    :rel="item.type != 'path' ? 'noopener noreferrer' : null" :class="[
                      'rounded-full mobile:w-full mobile:block largeDesktop:inline-block font-roboto',
                      'tablet:py-2 laptop:px-7 mobile:py-1.5 mobile:text-[15px]',
                      'mobile:px-4 py-2.5 no-underline CustomYellowBtn border-[1px] border-[#F5B134] bg-[#FDF9EE] !shadow-none laptop:hover:!shadow-[0px_5px_10px_0px_#f5b13466]',
                    ]">
                    {{ item.label }}
                  </component>
                </li>
              </ul>

              <!-- Right Side Nav -->
              <div
                class="flex items-center mobile:justify-between laptop:justify-end mobile:gap-2 laptop:w-1/2 laptop:gap-3 w-full mobile:mb-[20px] laptop:py-0 mobile:py-2.5 laptop:mb-0 border-b border-[#EFEFEF] laptop:border-0">
                <ul class="laptop:hidden navbar-nav mobile:gap-2.5">
                  <li v-for="(item, index) in getNavItems" :key="index">
                    <component :is="item.type == 'path' ? 'router-link' : 'a'"
                      :to="item.type == 'path' ? item.link : null" @click="isMobileMenuOpen = false"
                      :href="item.type != 'path' ? item.link : null" :target="item.type != 'path' ? '_blank' : null"
                      :rel="item.type != 'path' ? 'noopener noreferrer' : null" :class="[
                        'rounded-full inline-block font-roboto',
                        'text-[15px] px-[40px] py-1.5 no-underline transition-colors [border:1px_solid_#F5B134] !bg-[#FDF9EE] text-black-100 cursor-pointer',
                      ]">
                      {{ item.label }}
                    </component>
                  </li>
                </ul>
                <div id="tour-role-badge-desktop" class="mobile:hidden laptop:block">
                  <div v-if="user.user.affiliate.affiliate_type == 'normal'"
                    class="flex items-center justify-center gap-1.5 text-[14px] px-[15px] h-[30px] rounded-full font-roboto font-semibold shadow-custom text-[#666666]">
                    <img src="../../../assets/images/people-icon.png" class="w-[20px] h-[20px] object-contain"
                      alt="icon">
                    Standard Affiliate
                  </div>
                  <div v-else-if="user.user.affiliate.affiliate_type == 'master'"
                    class="flex items-center justify-center gap-1.5 text-[14px] px-[15px] h-[30px] rounded-full font-roboto font-semibold shadow-custom text-[#666666]">
                    <img src="../../../assets/images/master-icon.png" class="w-[20px] h-[20px] object-contain"
                      alt="icon">
                    Master Affiliate
                  </div>
                  <div v-else-if="user.user.affiliate.affiliate_type == 'employee'"
                    class="flex items-center justify-center gap-1.5 text-[14px] px-[15px] h-[30px] rounded-full font-roboto font-semibold shadow-custom text-[#666666]">
                    <img src="../../../assets/images/building-icon.png" class="w-[20px] h-[20px] object-contain"
                      alt="icon">
                    Employee
                  </div>
                </div>
                <!-- Profile Button -->
                <div class="relative w-14 h-14 flex items-center">
                  <button id="tour-profile-pic" @click="profileModal()" class="inline-flex justify-center items-center">
                    <img :src="user ? user.user.profile_picture : ''" alt="User Profile Icon"
                      class="w-[50px] h-[50px] object-cover rounded-full">
                  </button>
                </div>
              </div>

              <div class="mobile:order-first laptop:hidden pb-4">
                <button @click="signoutClicked" type="button"
                  class="mt-5 mx-2 text-[15px] rounded-full no-underline font-roboto font-semibold flex justify-center items-center !min-w-[180px] h-[40px] CustomYellowBtn">Sign
                  Out</button>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  </div>

  <!-- Profile Modal -->
  <div class="modal fade" id="profileModal" ref="profileModal" tabindex="-1" aria-labelledby="profileModal"
    aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[400px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <div class="modal-content select-none">
        <div class="modal-body !p-2.5 !pb-5">
          <div class="relative ">
            <button type="button"
              class="absolute top-3 right-[10px] w-[30px] h-[30px] z-50 focus:!outline-none focus:!shadow-none"
              data-bs-dismiss="modal" aria-label="Close">
              <!-- <font-awesome-icon icon="times" class="w-full h-full font-light text-white" /> -->
              <img src="../../../assets/images/white-cross-icon.svg" alt="Cross Icon"
                class="w-[30px] h-[30px] object-contain">
            </button>
          </div>
          <div class="">
            <headerUserProfile :openModal="profileModalOpen" :bootme="bootMeUpData" :clickedCallback="clickedCallback"
              :userObject="user" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Notification Modal -->
  <headerNotification :openPopup="openNotificationPopup" />
</template>

<script>
import { Modal } from "bootstrap";
import {
  mapGetters, mapActions
} from "vuex";
import headerMessage from "../../nest_components/header_message.vue";
import headerNotification from "../../nest_components/header_notification.vue";
import headerUserProfile from "../../nest_components/header_profile.vue";
import switchSlider from "../../partialComponent/customSwitchSlider.vue";
// import globalSearch from '../../partialComponent/customInput.vue';
import sidebarNavigation from '../../../components/sidebarNavigation.vue';
import showIcon from '../../../assets/images/searchBar-icon.png';
import hideIcon from '../../../assets/images/crossIcon.png';
import EventBus from "@/plugins/EventBus";

// import sidebar from "../../nest_components/omega_sidebar/sidebar.vue";
export default {
  components: {
    headerMessage,
    headerNotification,
    headerUserProfile,
    switchSlider,
    // globalSearch,
    sidebarNavigation,
    // sidebar
  },
  data() {
    return {
      loading: false,
      search: '',
      isScrolled: false,
      searchIcon: showIcon,
      crossIcon: hideIcon,
      searchOpen: false,
      navItems: [],
      isMobileMenuOpen: false, // ← Add this
      profileModalOpen: new Date(),
      user: JSON.parse(localStorage.getItem('user')) ?? null,
      openNotificationPopup: new Date()
    };
  },
  computed: {
    ...mapGetters(["setCompanyInfo", "saveCompanyInfo", "maintenanceBannerData", "bootMeUpData", "userObject", "updateStatusResponse", "signOutResponse", "notificationCountResponse"]),
    notificationCount() {
      return this.notificationCountResponse ? this.notificationCountResponse.unread : 0
    },

    getNavItems() {
      if (this.$route.name == 'dashboard') {
        this.navItems = [
          //{ label: 'Contact Us', link: '#', type: "path"}
          // { label: 'Contact Us', link: 'https://fyxify.pro/index.html#ContactUs', type: "url"}
        ]
      } else {
        this.navItems = [
          { label: 'Dashboard', link: '/dashboard', type: "path" },
          // { label: 'Contact Us', link: '#', type: "path"}
          // { label: 'Contact Us', link: 'https://fyxify.pro/index.html#ContactUs', type: "url"}
        ]
      }
      return this.navItems
    },

  },

  watch: {
    isMobileMenuOpen(newVal) {
      if (newVal) {
        // When menu opens
        const el = document.getElementById('scrollContainer');
        if (el) {
          el.style.setProperty('overflow', 'hidden', 'important');
        }
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        // When menu closes
        const el = document.getElementById('scrollContainer');

        if (el) {
          el.style.removeProperty('overflow');
        }
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        this.searchOpen = false;
      }
    },

    updateStatusResponse: function () {
      this.getProfile({})
    },

    userObject: function () {
      this.user = this.userObject
      localStorage.setItem('user', JSON.stringify(this.user))
    },

    bootMeUpData: function () { },

    signOutResponse: function (val) {
      if (val) {
        localStorage.removeItem('user')
        localStorage.removeItem('isSilentLogin')
        localStorage.removeItem('isProtectionPlans')
        localStorage.removeItem('is_from_mobile')
        this.resetSate()
        this.$router.replace({
          name: 'login'
        })
      }
    },

    '$route.query': {
      immediate: true,
      handler(newQuery) {
        if (newQuery) {
          this.search = this.$route.query.q
        }

        if (this.$route.name == 'globalSearch') {
          this.$nextTick(() => {
            const isMobile = window.innerWidth < 1024
            const isCollapsed = !document.getElementById('globalSearch')?.classList.contains('show');

            if (isMobile && isCollapsed) {
              this.$refs.searchButton.click();
            }
          });
        }
      },
    },
  },

  mounted() {
    const is_from_mobile = localStorage.getItem("is_from_mobile", 0) ?? 0
    if (is_from_mobile != '1') {
      this.getProfile({})
      this.getBootMeData({})
    }
    this.setNavItems()
    const el = document.getElementById('scrollContainer');

    if (el) {
      el.addEventListener("scroll", this.handleScroll);
    }

    document.body.style.overflow = 'hidden';
    EventBus.on('openMobileMenu', () => {
      this.isMobileMenuOpen = true
    });
    window.forceOpenMobileMenu = () => {
      this.isMobileMenuOpen = true;
    };
  },
  beforeUnmount() {
    EventBus.off('openMobileMenu');
    delete window.forceOpenMobileMenu;
    const el = document.getElementById('scrollContainer');

    if (el) {
      el.removeEventListener("scroll", this.handleScroll);
    }
    document.body.style.overflow = '';
  },
  methods: {
    ...mapActions(["getCompanyInfo", "getMaintenanceBannerData", "getBootMeData", "updateStatus", "getProfile", "signOut", "resetSate", "unreadNotificationsCount"]),

    logoClicked() {
      this.$router.push('/dashboard');

    },
    setNavItems() {
      if (this.$route.name == 'dashboard') {
        this.navItems = [
          { label: 'Contact Us', link: '#' }
          // { label: 'Contact Us', link: 'https://fyxify.pro/index.html#ContactUs' }
        ]
      } else {
        this.navItems = [
          { label: 'Dashboard', link: '/dashboard' },
          { label: 'Contact Us', link: '#' }
          // { label: 'Contact Us', link: 'https://fyxify.pro/index.html#ContactUs' }
        ]
      }
    },


    adjustModalHeight() {
      const modalContent = this.$refs.profileModal?.querySelector('.profile-modal-content');
      if (modalContent) {
        const vh = window.innerHeight;
        modalContent.style.maxHeight = `${vh - 200}px`; // adjust padding as needed
        modalContent.style.overflowY = 'auto';
      }
    },

    clickedCallback(option) {
      if (option == 'signout') {
        this.signoutClicked()
      }
    },
    signoutClicked() {
      const originalPadding = document.documentElement.style.padding || '';
      // Remove padding from HTML element
      document.documentElement.style.padding = '0';
      document.documentElement.style.paddingRight = '0';
      this.$confirmDialog.show({
        image: 'logout-confirm-icon.svg',
        title: "Sign Out",
        text: "Are you sure you want to sign out?",
        buttonText: "Confirm",
        isShowConfirmText: true,
        // image: "pop-req-img.png",
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.signOut({})
        },
      });
    },

    notificationModal() {
      this.openNotificationPopup = new Date()
    },

    sideMenuClicked() {
      this.isMobileMenuOpen = false
    },
    handleNavClick(item) {
      this.isMobileMenuOpen = false;

      // Collapse any open Bootstrap navbars
      const collapseElements = document.querySelectorAll('.navbar-collapse');
      collapseElements.forEach(el => {
        if (el.classList.contains('show')) {
          new this.Collapse(el).hide();
        }
      });

      // Route to the correct page
      this.$router.push(item.link);
    },
    handleScroll() {
      const el = document.getElementById('scrollContainer');
      if (!el) return;

      this.isScrolled = el.scrollTop > 50;
    },

    handleStatusChange(isOnline) {

      this.updateStatus({
        active: isOnline ? '1' : '0',
        lat: '0',
        long: '0',
      })
    },
    toggleSearch() {
      this.searchOpen = !this.searchOpen
    },
    profileModal() {
      const { Modal } = require('bootstrap');
      const modalEl = this.$refs.profileModal;
      this.sideMenuClicked()
      let modal = Modal.getInstance(modalEl);
      if (!modal) {
        modal = new Modal(modalEl, {
          backdrop: 'static',
          keyboard: false
        });
      }
      // Add event listeners for show/hide
      modalEl.addEventListener('show.bs.modal', () => {
        this.adjustModalHeight();
      });
      modalEl.addEventListener('hidden.bs.modal', () => {
        window.removeEventListener('resize', this.adjustModalHeight);
        window.removeEventListener('orientationchange', this.adjustModalHeight);
      });

      this.profileModalOpen = new Date()
      // Add orientation/resize responsiveness
      window.addEventListener('resize', this.adjustModalHeight);
      window.addEventListener('orientationchange', this.adjustModalHeight);
      modal.show();
    },
    backButton() {
      this.isMobileMenuOpen = false
      this.$router.go(-1);
    },
    setLoading() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 200);
    },
    handleClear() {
      this.search = ''
      this.handleSearch()
    },
    handleSearch() {
      let search = ""
      search = this.$helper.isEmpty(this.search) ? '' : this.search.trim()
      this.setLoading()
      if (this.$route.name == 'globalSearch') {
        this.$router.replace({
          name: 'globalSearch',
          query: {
            q: search,
            t: Date.now()
          },
        });
      } else {
        this.$router.push({
          name: 'globalSearch',
          query: {
            q: search,
            t: Date.now()
          },
        });
      }
    }
  }
};
</script>
<style>
@media (max-width: 768px) {

  .collapse:not(.show) {
    display: none;
  }

  .collapse.show {
    display: block;
    height: auto;
    visibility: visible;
  }
}

@media (min-width: 768px) {

  .collapse:not(.show) {
    display: none
  }

  .collapse.show {
    display: block;
    height: auto;
    visibility: visible;
  }
}

a.router-link-active {
  border-bottom: 0 !important;
}
.header-container:has(>.driver-active-element){
   overflow: visible !important;
}
</style>